<div id="chartContainerpays" style="height: 370px; width: 100%; direction: ltr; margin-left:auto;margin-right:auto;"></div>